module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/form_diagram_es-e9b09e295079552c8337facf350e9724.png";